import { z } from 'zod'

import { richTextDocSchema } from '../cms.rich-text'
import { blockOf } from './common'
import { BlockType } from './types'

/**
 * Heading size of a TEXT block. `H1` is the large section title, `H2` one step down at both
 * breakpoints. Defaulting to `H1` keeps blocks stored before this field existed looking the same.
 */
export const TextHeadingStyle = {
    H1: 'H1',
    H2: 'H2',
} as const

export type TextHeadingStyle = (typeof TextHeadingStyle)[keyof typeof TextHeadingStyle]

export const textHeadingStyleSchema = z.enum(TextHeadingStyle)

export const textBlockSchema = z.object({
    ...blockOf(BlockType.TEXT),
    title: z.string(),
    body: richTextDocSchema,
    headingStyle: textHeadingStyleSchema.default(TextHeadingStyle.H1),
})

export type TextBlockData = z.infer<typeof textBlockSchema>
